import { jsx as _jsx } from "react/jsx-runtime";
import styles from './LineWobble.scss';
const LineWobble = ({ size = 80, color = 'black', speed = 1.75, stroke = 5, bgOpacity = 0.1, }) => {
    return (_jsx("div", { className: styles.container, style: {
            '--uib-size': size + 'px',
            '--uib-color': color,
            '--uib-speed': speed + 's',
            '--uib-stroke': stroke + 'px',
            '--uib-bg-opacity': bgOpacity + '',
        }, children: _jsx("div", { className: styles.inner }) }));
};
export default LineWobble;
